var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.89 144.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5382a1;}.cls-2{fill:#e76f00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.17,111.48s-5.17,3.21,3.68,4.29c10.74,1.3,16.22,1.12,28.05-1.27a47.66,47.66,0,0,0,7.45,3.88c-26.51,12.09-60-.7-39.18-6.9M28.93,95.7s-5.8,4.57,3.06,5.55c11.47,1.26,20.52,1.36,36.19-1.85A16,16,0,0,0,73.75,103c-32,10-67.76.79-44.82-7.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.24,68.93c6.54,8-1.71,15.21-1.71,15.21s16.59-9.12,9-20.53C56.38,53,50.93,47.68,80.47,29.44c0,0-46.37,12.33-24.23,39.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.31,123.16s3.83,3.36-4.22,6c-15.3,4.93-63.69,6.42-77.14.19-4.83-2.24,4.23-5.34,7.08-6a17.18,17.18,0,0,1,4.67-.56c-5.37-4-34.73,7.91-14.91,11.33,54.06,9.33,98.54-4.2,84.52-10.93M34.66,79.35S10,85.57,25.94,87.83c6.72,1,20.1.74,32.56-.37,10.19-.92,20.42-2.86,20.42-2.86a42.51,42.51,0,0,0-6.19,3.53c-25,7-73.29,3.74-59.39-3.42,11.76-6,21.32-5.36,21.32-5.36m44.16,26.27c25.41-14.05,13.66-27.56,5.46-25.74a17.68,17.68,0,0,0-2.91.83,4.75,4.75,0,0,1,2.17-1.78c16.23-6.07,28.71,17.9-5.23,27.4a2.48,2.48,0,0,0,.51-.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.5,0S77.57,15,50.15,38c-22,18.49-5,29,0,41.06C37.31,66.76,27.89,55.91,34.21,45.81,43.48,31,69.18,23.8,63.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.16,143.7c24.39,1.66,61.84-.92,62.73-13.2,0,0-1.7,4.65-20.16,8.35-20.82,4.17-46.49,3.68-61.72,1,0,0,3.12,2.75,19.15,3.84"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/JAVA.3480b38b49064b4558d8b8f04f28c792.svg";
export { ForwardRef as ReactComponent };